var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowupimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "179.000000pt",
    height: "168.000000pt",
    viewBox: "0 0 179.000000 168.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,168.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 1535 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 1535 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912 1550 c7 -10 14 -18 15 -16 6 6 -9 36 -18 36 -5 0 -4 -9 3 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966 1543 c10 -40 14 -41 14 -5 0 18 -5 32 -10 32 -6 0 -8 -11 -4 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432 1540 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 1525 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2 0 -6 -11 -8 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032 1525 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061 1534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312 1525 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611 1534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 1522 c1 -8 3 -16 3 -18 0 -3 5 -2 10 1 6 3 10 11 10 16 0 6 -4 8 -9 5 -5 -4 -11 -3 -14 1 -2 5 -2 2 0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 1526 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 1520 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 1526 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 1514 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 1521 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156 1513 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1510 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 1261 c-80 -28 -175 -87 -187 -116 -9 -23 8 -18 50 16 104 84 255 123 387 101 84 -15 178 -56 229 -101 42 -36 64 -42 48 -11 -18 34 -111 89 -193 115 -112 36 -224 35 -334 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315 1262 c-33 -7 -55 -33 -55 -66 1 -41 20 -64 58 -72 24 -5 36 -1 56 19 53 54 13 134 -59 119z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 1238 c-9 -12 -16 -33 -16 -46 0 -26 41 -72 65 -72 20 0 57 19 67 34 14 21 8 73 -10 89 -28 25 -87 22 -106 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 1104 c-36 -19 -48 -43 -48 -93 l0 -41 130 0 130 0 0 46 c0 37 -5 51 -30 76 -24 23 -36 28 -53 23 -29 -10 -58 -10 -82 -2 -11 3 -32 -1 -47 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253 1109 c-32 -12 -53 -49 -53 -96 l0 -43 130 0 130 0 0 35 c0 73 -52 125 -104 105 -14 -5 -37 -5 -53 -1 -15 5 -38 5 -50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 1049 c-4 -6 22 -39 59 -76 59 -60 87 -73 87 -40 0 18 -107 127 -124 127 -8 0 -18 -5 -22 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711 994 c-30 -39 -41 -87 -29 -131 22 -80 118 -193 231 -271 74 -52 121 -60 181 -33 70 30 69 43 -10 122 -38 38 -70 65 -72 59 -9 -25 -54 -8 -103 40 -47 44 -51 52 -46 83 5 32 0 39 -57 96 -34 33 -64 61 -68 61 -4 0 -16 -12 -27 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 938 c-30 -91 -34 -234 -9 -319 46 -156 167 -291 312 -348 39 -16 51 -17 55 -7 3 8 -13 19 -44 31 -63 22 -155 89 -201 146 -111 136 -143 304 -92 487 7 23 -13 33 -21 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374 929 c4 -13 12 -57 18 -97 36 -237 -97 -451 -339 -548 -15 -6 -20 -13 -14 -22 13 -21 162 62 227 126 61 62 115 150 138 231 29 100 14 317 -23 329 -11 4 -12 -1 -7 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 769 c-8 -13 115 -141 131 -136 22 8 7 39 -44 92 -53 55 -74 65 -87 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 460 c-26 -10 -48 -61 -39 -90 10 -32 63 -54 98 -41 55 21 56 105 1 130 -29 13 -32 13 -60 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797 290 c-22 -19 -30 -38 -34 -73 l-6 -47 138 0 138 0 -6 46 c-8 73 -36 94 -122 97 -56 0 -67 -3 -98 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232 205 l-10 -63 117 0 117 0 -7 64 c-11 100 -29 134 -85 122 -25 -6 -50 -7 -58 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupimage);
export default __webpack_public_path__ + "static/media/followupimage.aca7aba3e4cc7a780dab98467b39131e.svg";
export { ForwardRef as ReactComponent };